export const SERVICES = [
  {
    slug: "house-cleaning",
    name: "House Cleaning",
    short: "House Cleaning",
    category: "Residential",
    icon: "Home",
    tagline: "Professional recurring house cleaning — weekly, bi-weekly, or monthly — tailored to your household.",
    description: [
      "A consistently clean home without giving up your weekends. Tbay Cleaning Services' house cleaning service pairs you with a dedicated, background-checked crew that learns your home, your priorities, and your schedule.",
      "Every visit follows our 50-point residential checklist, from kitchen counters and bathrooms to baseboards and interior glass, using eco-conscious products that are safe for kids and pets.",
    ],
    includes: [
      "Kitchen counters, sinks & appliance exteriors",
      "Bathrooms scrubbed, sanitized & polished",
      "Dusting of all accessible surfaces",
      "Vacuuming of carpets, rugs & stairs",
      "Mopping of all hard floors",
      "Mirrors & interior glass spot-cleaned",
      "Beds made & linens changed on request",
      "Trash & recycling emptied",
      "Baseboards, sills & switch plates wiped",
      "Interior windows available on request",
    ],
    process: [
      { t: "Walkthrough & quote", d: "Tell us about your home and get a flat-rate quote the same day." },
      { t: "First deep reset", d: "We bring your home to baseline with a detailed first clean." },
      { t: "Recurring schedule", d: "Weekly, bi-weekly, or monthly visits with the same trusted crew." },
      { t: "Quality check-ins", d: "Supervisor audits and a spotless-service guarantee on every visit." },
    ],
    keywords: ["house cleaning services", "home cleaning", "residential cleaning", "house cleaners near me", "professional house cleaning", "weekly house cleaning", "house cleaning company", "local house cleaners", "affordable house cleaning", "home cleaning services Canada"],
    priceFactors: ["Square footage & number of rooms", "Cleaning frequency (weekly vs monthly)", "Pets, kids & household traffic", "Add-ons like interior windows or oven cleaning"],
    faqs: [
      { q: "How much does house cleaning cost in {city}?", a: "Pricing depends on home size, condition, and frequency. Most {city} homes receive a flat-rate quote within one business hour — call {phone} or email {email} for your free estimate." },
      { q: "Will I get the same cleaners each visit in {city}?", a: "Yes. Recurring {city} clients are paired with a dedicated crew so the same trusted professionals clean your home every visit." },
      { q: "Do I need to be home during the cleaning?", a: "Not at all. Most {city} clients provide a key, code, or concierge instructions. Every visit is logged and fully insured for your peace of mind." },
    ],
  },
  {
    slug: "deep-cleaning",
    name: "Deep Cleaning",
    short: "Deep Cleaning",
    category: "Residential",
    icon: "Sparkles",
    tagline: "Intensive top-to-bottom deep cleaning that resets every corner of your space.",
    description: [
      "Deep cleaning goes far beyond a standard tidy. Our crews degrease kitchens, descale bathrooms, hand-wipe baseboards, clean inside appliances, and reach the spots regular cleaning never touches.",
      "It is the ideal seasonal reset, pre-listing detail, or first visit before starting a recurring schedule — a full top-to-bottom restoration of your home's cleanliness.",
    ],
    includes: [
      "Inside ovens, fridges & microwaves",
      "Cabinet fronts & interior shelving wiped",
      "Limescale & soap-scum removal in bathrooms",
      "Baseboards, door frames & trim hand-wiped",
      "Light fixtures, vents & ceiling fans dusted",
      "Behind & under furniture and appliances",
      "Interior windows, tracks & sills",
      "Grout scrubbing & detail brush work",
      "Wall spot-cleaning & switch plates",
      "Full floor detail including edges & corners",
    ],
    process: [
      { t: "Priority list", d: "You flag the rooms and problem areas that matter most." },
      { t: "Zone-by-zone detail", d: "Crews work top-down, room-by-room through the 50-point checklist." },
      { t: "Detail pass", d: "Edges, corners, grout, and fixtures get a dedicated second pass." },
      { t: "Final walkthrough", d: "We review the result with you before we call it done." },
    ],
    keywords: ["deep cleaning services", "deep house cleaning", "one-time deep clean", "spring cleaning services", "deep clean company", "detailed cleaning service", "top to bottom cleaning", "deep cleaning near me", "kitchen deep clean", "bathroom deep clean"],
    priceFactors: ["Current condition & time since last deep clean", "Square footage & bathrooms count", "Inside-appliance add-ons", "Pet hair or heavy buildup"],
    faqs: [
      { q: "How long does a deep clean take in {city}?", a: "Most {city} homes take 4–8 hours depending on size and condition. Larger homes get multi-person crews so the work finishes in a single day." },
      { q: "What's the difference between deep cleaning and regular cleaning?", a: "Regular cleaning maintains; deep cleaning restores. It targets buildup, grout, inside appliances, baseboards, and areas outside a standard maintenance visit." },
      { q: "How often should I book a deep clean?", a: "Most {city} households book a deep clean seasonally — two to four times a year — then maintain with recurring visits in between." },
    ],
  },
  {
    slug: "move-in-out-cleaning",
    name: "Move-In & Move-Out Cleaning",
    short: "Move-In/Move-Out Cleaning",
    category: "Real Estate",
    icon: "Truck",
    tagline: "Deposit-securing, handover-ready deep cleans for tenants, landlords, and sellers.",
    description: [
      "Moving is stressful enough. Our move-in and move-out cleaning service delivers an empty-home deep clean that satisfies landlords, property managers, and buyers — and protects your damage deposit.",
      "We clean inside every cabinet, closet, and appliance, following the checklists Canadian property managers actually use for final inspections.",
    ],
    includes: [
      "Inside all cabinets, drawers & closets",
      "Inside oven, fridge & dishwasher",
      "Bathroom descaling & full sanitization",
      "Baseboards, doors & door frames",
      "Interior windows, tracks & sills",
      "Wall spot-cleaning & marks removal",
      "Light fixtures & vent covers",
      "Full vacuum & mop of all floors",
      "Garage, balcony & storage sweeps",
      "Final inspection-ready detailing",
    ],
    process: [
      { t: "Book your date", d: "We align the clean with your key handover or possession date." },
      { t: "Empty-home deep clean", d: "Full top-to-bottom detail of the vacant property." },
      { t: "Inspection checklist", d: "We work to the same checklist property managers use." },
      { t: "Photo confirmation", d: "Time-stamped photos sent to you or your landlord on completion." },
    ],
    keywords: ["move out cleaning", "move in cleaning", "end of tenancy cleaning", "move in move out cleaning services", "apartment move out cleaning", "deposit back cleaning", "vacancy cleaning service", "rental turnover cleaning", "move out cleaners near me", "end of lease cleaning"],
    priceFactors: ["Size of the empty property", "Condition at handover", "Inside-appliance detailing", "Rush or same-weekend bookings"],
    faqs: [
      { q: "Will move-out cleaning in {city} get my deposit back?", a: "Our {city} move-out cleans follow the same checklists local property managers use, and we provide time-stamped photo proof — the two things that most protect your deposit." },
      { q: "Should the home be empty?", a: "Ideally yes. Move-in/out cleans are most thorough once furniture is out, but we can work around remaining items when needed." },
      { q: "How fast can you book a move-out clean in {city}?", a: "We hold daily slots for {city} moves. Call {phone} — end-of-month dates fill first, so booking a week ahead is smart." },
    ],
  },
  {
    slug: "commercial-cleaning",
    name: "Commercial & Office Cleaning",
    short: "Commercial Cleaning",
    category: "Commercial",
    icon: "Building2",
    tagline: "Scheduled commercial and office cleaning programs for workspaces of every size.",
    description: [
      "A clean workplace drives productivity, impresses clients, and protects staff health. Tbay Cleaning Services builds custom commercial cleaning programs for offices, retail, clinics, and shared spaces — daily, nightly, or weekly.",
      "You get an assigned crew, a dedicated supervisor, and monthly quality audits, all under one transparent flat-rate contract.",
    ],
    includes: [
      "Workstations, desks & shared surfaces",
      "Washrooms cleaned, sanitized & restocked",
      "Breakrooms & kitchenettes detailed",
      "Trash, recycling & compost removal",
      "Vacuuming & hard-floor machine care",
      "Entrance glass & door detailing",
      "Boardrooms & reception resets",
      "High-touch point disinfection",
      "Dusting of vents, sills & fixtures",
      "Day-porter services available",
    ],
    process: [
      { t: "Site walkthrough", d: "We tour your facility and map scope, traffic, and priorities." },
      { t: "Custom schedule", d: "Daily, nightly, or weekly program built around your hours." },
      { t: "Assigned crew", d: "The same vetted team services your site, supervised on a schedule." },
      { t: "Monthly audits", d: "Scored quality inspections with a direct line to your account manager." },
    ],
    keywords: ["commercial cleaning services", "office cleaning", "business cleaning services", "commercial cleaners", "office cleaning services", "workplace cleaning", "commercial cleaning company", "office cleaners near me", "nightly office cleaning", "commercial cleaning contract"],
    priceFactors: ["Facility square footage & layout", "Service frequency & hours", "Washroom and kitchenette count", "Specialized flooring or equipment care"],
    faqs: [
      { q: "Do you clean offices after hours in {city}?", a: "Yes — most {city} commercial clients are serviced evenings or early mornings so your team arrives to a fresh workspace every day." },
      { q: "Are your commercial crews insured?", a: "Every Tbay Cleaning Services crew in {city} is fully insured, bonded, and background-checked, with supervisor oversight on commercial accounts." },
      { q: "Do you require long contracts?", a: "No. Most {city} clients run month-to-month programs. We keep contracts simple and let the quality keep you." },
    ],
  },
  {
    slug: "carpet-cleaning",
    name: "Carpet & Upholstery Cleaning",
    short: "Carpet Cleaning",
    category: "Specialty",
    icon: "Sofa",
    tagline: "Hot-water extraction that lifts deep stains, allergens, and odours from carpets and furniture.",
    description: [
      "Vacuuming only touches the surface. Our professional hot-water extraction carpet cleaning pulls embedded dirt, allergens, pet odours, and stains from deep in the pile — extending carpet life and improving indoor air quality.",
      "We treat high-traffic lanes, pre-treat stains, groom the pile, and use rapid-dry techniques so your space is back in service fast.",
    ],
    includes: [
      "Pre-inspection & fibre testing",
      "Pre-treatment of stains & traffic lanes",
      "Hot-water extraction (steam) cleaning",
      "Pet stain & odour treatments",
      "Upholstery & sofa deep cleaning",
      "Area rug cleaning",
      "Deodorizing & sanitizing options",
      "Carpet protector application",
      "Rapid-dry air movers",
      "Pile grooming & final inspection",
    ],
    process: [
      { t: "Inspect & test", d: "We identify fibres, stains, and the safest method for each area." },
      { t: "Pre-treat", d: "Stains and traffic lanes get targeted professional treatment." },
      { t: "Extract", d: "Truck-grade hot-water extraction flushes soil from deep in the pile." },
      { t: "Dry & groom", d: "Rapid drying and pile grooming leave a like-new finish." },
    ],
    keywords: ["carpet cleaning services", "carpet steam cleaning", "rug cleaning", "upholstery cleaning", "carpet shampooing", "professional carpet cleaners", "carpet stain removal", "pet odour removal", "commercial carpet cleaning", "carpet cleaners near me"],
    priceFactors: ["Total carpeted area", "Stain & pet-treatment requirements", "Upholstery pieces added", "Furniture moving needs"],
    faqs: [
      { q: "How long do carpets take to dry in {city}?", a: "With our rapid-dry process, most {city} carpets dry in 4–8 hours. Air movers cut that significantly for commercial sites." },
      { q: "Can you remove pet odours and stains?", a: "Yes — we use enzyme treatments that neutralize pet urine at the source rather than masking it, followed by deep extraction." },
      { q: "How often should carpets be professionally cleaned?", a: "Homes: every 12–18 months (6–12 with pets or kids). {city} commercial spaces with heavy traffic: every 3–6 months." },
    ],
  },
  {
    slug: "window-cleaning",
    name: "Window Cleaning",
    short: "Window Cleaning",
    category: "Specialty",
    icon: "Droplets",
    tagline: "Streak-free interior and exterior window cleaning for homes and storefronts.",
    description: [
      "Clean glass changes how a whole building feels. Our window cleaning crews deliver streak-free interior and exterior results for houses, storefronts, offices, and low-rise commercial buildings.",
      "We hand-detail frames, tracks, and sills — not just the glass — and use pure-water systems for a spot-free finish even in hard-water areas.",
    ],
    includes: [
      "Exterior window washing",
      "Interior glass & mirror detailing",
      "Frames, tracks & sill cleaning",
      "Screen removal & washing",
      "Skylights & glass railings",
      "Storefront glass programs",
      "Hard-water stain removal",
      "French panes & divided lights",
      "Post-construction glass cleaning",
      "Pure-water spot-free rinse",
    ],
    process: [
      { t: "Count & quote", d: "A quick pane count gives you a firm per-visit price." },
      { t: "Detail the frames", d: "Tracks, sills, and screens are cleaned before the glass." },
      { t: "Streak-free wash", d: "Professional squeegee work plus pure-water rinse on exteriors." },
      { t: "Final polish", d: "Edges and corners hand-detailed for a flawless finish." },
    ],
    keywords: ["window cleaning services", "window washers", "residential window cleaning", "commercial window cleaning", "streak free window cleaning", "exterior window cleaning", "interior window cleaning", "window cleaning company", "storefront window cleaning", "window cleaners near me"],
    priceFactors: ["Number & size of panes", "Interior, exterior, or both", "Height & accessibility", "Screen and track detailing"],
    faqs: [
      { q: "How often should windows be cleaned in {city}?", a: "Most {city} homes book twice a year — spring and fall. Storefronts and restaurants typically run monthly or bi-weekly programs." },
      { q: "Do you clean windows in winter?", a: "Yes, weather permitting. We use cold-weather-safe solutions and schedule around deep-freeze days common in {province}." },
      { q: "Are tracks and frames included?", a: "Yes. Unlike splash-and-dash services, every Tbay window visit includes tracks, sills, and frames hand-wiped." },
    ],
  },
  {
    slug: "post-construction-cleaning",
    name: "Post-Construction Cleaning",
    short: "Post-Construction Cleaning",
    category: "Specialty",
    icon: "HardHat",
    tagline: "Rough, final, and sparkle cleans that take new builds from site to showroom.",
    description: [
      "Construction dust gets everywhere — inside cabinets, ductwork, and window tracks. Our post-construction cleaning teams handle rough cleans, final cleans, and pre-occupancy sparkle cleans for builders, contractors, and homeowners.",
      "We remove sticker residue, paint splatter, drywall dust, and debris, then detail every surface so the space passes inspection and photographs beautifully.",
    ],
    includes: [
      "Fine dust extraction from all surfaces",
      "Inside cabinets, drawers & closets",
      "Window, frame & track detailing",
      "Sticker, tape & paint-splatter removal",
      "Floor scrubbing, polishing & protection removal",
      "Bathroom & kitchen fixture detailing",
      "Vent covers & duct openings vacuumed",
      "Debris & leftover material removal",
      "High-dusting of beams & ledges",
      "Pre-occupancy sparkle clean",
    ],
    process: [
      { t: "Rough clean", d: "Debris, dust, and material removal mid-build or post-trade." },
      { t: "Final clean", d: "Full detail of every surface once construction wraps." },
      { t: "Sparkle clean", d: "Pre-handover polish so the space shows perfectly." },
      { t: "Sign-off walkthrough", d: "We walk the site with your PM before handover." },
    ],
    keywords: ["post construction cleaning", "construction cleanup", "after builders cleaning", "renovation cleaning", "final clean construction", "construction dust removal", "new build cleaning", "rough and final clean", "post renovation cleaning", "builders clean"],
    priceFactors: ["Project square footage", "Phase: rough, final, or sparkle", "Debris & material volume", "Timeline & crew size required"],
    faqs: [
      { q: "Do you work with contractors and builders in {city}?", a: "Yes — most of our {city} post-construction work is for builders, renovators, and developers on rough, final, and sparkle schedules." },
      { q: "Can you handle fine drywall dust?", a: "That is the core of the job. We use HEPA-filtered extraction and multi-pass dusting so fine construction dust is actually removed, not spread around." },
      { q: "How quickly can you turn a site around?", a: "Crews scale to the deadline. A typical {city} new-build home final cleans in one day; commercial spaces are scheduled phase by phase." },
    ],
  },
  {
    slug: "airbnb-cleaning",
    name: "Airbnb & Short-Term Rental Cleaning",
    short: "Airbnb Cleaning",
    category: "Short-Term Rental",
    icon: "KeyRound",
    tagline: "Five-star turnover cleaning with same-day flips, linen service, and restocking.",
    description: [
      "Reviews live and die on cleanliness. Our Airbnb and short-term rental cleaning service delivers hotel-standard turnovers: same-day flips, fresh linens, restocked essentials, and photo verification before every check-in.",
      "We sync with your booking calendar, flag damage or maintenance issues, and treat your listing like the business it is.",
    ],
    includes: [
      "Full turnover clean between guests",
      "Linen & towel changeover service",
      "Kitchen & bathroom hotel-standard detail",
      "Essentials restocking (paper, soap, coffee)",
      "Staging & presentation reset",
      "Damage & maintenance reporting",
      "Photo verification after each flip",
      "Same-day checkout-to-check-in flips",
      "Deep cleans between busy seasons",
      "Calendar-synced scheduling",
    ],
    process: [
      { t: "Calendar sync", d: "We connect to your booking calendar so turnovers schedule themselves." },
      { t: "Turnover clean", d: "Hotel-standard clean with linens changed and essentials restocked." },
      { t: "Stage & photograph", d: "Space reset to your listing photos, with time-stamped proof." },
      { t: "Report", d: "Damage, missing items, or maintenance issues flagged immediately." },
    ],
    keywords: ["airbnb cleaning service", "short term rental cleaning", "vacation rental cleaning", "airbnb turnover cleaning", "airbnb cleaners near me", "rental property cleaning", "host cleaning service", "airbnb linen service", "turnover cleaning", "vacation rental housekeeper"],
    priceFactors: ["Property size & bedroom count", "Linen service included or not", "Turnover frequency", "Restocking supply costs"],
    faqs: [
      { q: "Can you handle same-day turnovers in {city}?", a: "Yes — same-day flips are our specialty. We schedule crews around your {city} checkout and check-in windows with photo proof before guests arrive." },
      { q: "Do you provide linens?", a: "We offer full linen and towel programs, or we launder and reset yours — whichever fits your listing." },
      { q: "What if a guest damages something?", a: "Our crews photograph and report damage immediately after checkout, giving you time-stamped evidence for claims." },
    ],
  },
  {
    slug: "janitorial-services",
    name: "Janitorial Services",
    short: "Janitorial Services",
    category: "Commercial",
    icon: "Briefcase",
    tagline: "Daily janitorial programs, day porters, and building-wide facility care.",
    description: [
      "Reliable janitorial service is invisible when it's done right. Tbay Cleaning Services provides daily and nightly janitorial programs for offices, schools, medical facilities, retail, and multi-tenant buildings.",
      "Programs include restroom sanitation, consumables management, floor care, waste handling, and day porters — all supervised and quality-audited monthly.",
    ],
    includes: [
      "Daily & nightly cleaning programs",
      "Restroom sanitation & restocking",
      "Consumables & supply management",
      "Waste, recycling & compost handling",
      "Lobby, elevator & common-area care",
      "Day porter & matron services",
      "Hard-floor machine scrubbing",
      "Carpet spotting & vacuuming",
      "Touchpoint disinfection rounds",
      "Special event & emergency cleans",
    ],
    process: [
      { t: "Facility assessment", d: "We map your building's traffic, zones, and service needs." },
      { t: "Program design", d: "Task frequencies and schedules built to your budget." },
      { t: "Staffing & training", d: "Site-trained, background-checked janitors assigned to you." },
      { t: "Supervised delivery", d: "Monthly scored audits with transparent reporting." },
    ],
    keywords: ["janitorial services", "janitorial company", "commercial janitorial services", "nightly janitorial service", "day porter services", "janitorial cleaning services", "office janitorial", "building cleaning services", "janitorial services near me", "facility cleaning services"],
    priceFactors: ["Building size & occupant traffic", "Daily vs nightly scope", "Consumables management included", "Floor-care program frequency"],
    faqs: [
      { q: "What facilities do you service in {city}?", a: "Offices, schools, clinics, retail, places of worship, and multi-tenant buildings across {city} and {province} — from single floors to full facilities." },
      { q: "Do you manage supplies and consumables?", a: "Yes — we can fully manage paper, soap, and liner inventory so you never run out or over-order." },
      { q: "How is quality controlled?", a: "Every {city} janitorial account gets a working supervisor and monthly scored audits shared directly with you." },
    ],
  },
  {
    slug: "eco-friendly-cleaning",
    name: "Eco-Friendly & Green Cleaning",
    short: "Eco-Friendly Cleaning",
    category: "Residential",
    icon: "Leaf",
    tagline: "Certified green cleaning products and methods — spotless results, zero harsh chemicals.",
    description: [
      "Green cleaning without compromise. Our eco-friendly cleaning service uses certified non-toxic, biodegradable products and HEPA filtration to deliver a genuinely deep clean that's safe for children, pets, allergy sufferers, and the planet.",
      "Ideal for health-conscious households, daycares, wellness clinics, and workplaces pursuing greener operations.",
    ],
    includes: [
      "Certified green cleaning products",
      "Non-toxic, biodegradable solutions",
      "HEPA-filtered vacuuming",
      "Microfibre low-waste systems",
      "Fragrance-free options",
      "Allergy-aware cleaning protocols",
      "Green washroom & kitchen programs",
      "Recycling & waste-stream support",
      "Safe-for-pets product selection",
      "Indoor air-quality friendly methods",
    ],
    process: [
      { t: "Sensitivity review", d: "We note allergies, sensitivities, and product preferences." },
      { t: "Green product kit", d: "Certified eco products assigned to your home or facility." },
      { t: "HEPA-detail clean", d: "Full clean with filtration that traps allergens, not spreads them." },
      { t: "Ongoing program", d: "Recurring green schedules that keep indoor air healthy." },
    ],
    keywords: ["eco friendly cleaning", "green cleaning services", "natural cleaning products", "non toxic cleaning", "environmentally friendly cleaners", "green house cleaning", "eco cleaning company", "sustainable cleaning services", "chemical free cleaning", "organic cleaning service"],
    priceFactors: ["Home or facility size", "Specialty product requirements", "Service frequency", "Allergy or sensitivity protocols"],
    faqs: [
      { q: "Do green products actually clean as well?", a: "Yes — modern certified green products match conventional performance for residential and office soils, and our microfibre + HEPA methods boost results further." },
      { q: "Is eco cleaning safe for pets and kids in {city}?", a: "That is exactly the point. Every product we use on eco cleans is non-toxic and biodegradable — safe for the whole {city} household." },
      { q: "Does green cleaning cost more?", a: "Marginally on products, but most {city} clients find the difference minimal — and the health benefits immediate." },
    ],
  },
  {
    slug: "maid-service",
    name: "Maid Service",
    short: "Maid Service",
    category: "Residential",
    icon: "HeartHandshake",
    tagline: "Trusted recurring maid service — the same vetted professional, every visit.",
    description: [
      "Our maid service is built on trust: the same background-checked, fully insured cleaning professional visits your home on a set schedule, learns your preferences, and keeps your household running smoothly.",
      "Beyond cleaning, maids can handle laundry, linen changes, dish resets, and light organizing — the everyday tasks that keep a home feeling cared for.",
    ],
    includes: [
      "Recurring scheduled home cleaning",
      "The same dedicated maid each visit",
      "Kitchen & bathroom full detail",
      "Dusting, vacuuming & mopping",
      "Laundry & linen change service",
      "Beds made & bedrooms reset",
      "Dishes & kitchen reset",
      "Light organizing & tidying",
      "Fridge & oven cleaning on rotation",
      "Custom task lists per visit",
    ],
    process: [
      { t: "Meet your maid", d: "We match you with a dedicated, vetted cleaning professional." },
      { t: "Set your list", d: "Your priorities become a standing per-visit task list." },
      { t: "Recurring visits", d: "Same day, same time, same trusted person." },
      { t: "Adjust anytime", d: "Add tasks, change frequency, or pause with one call." },
    ],
    keywords: ["maid service", "maid services near me", "house maid cleaning", "professional maid service", "maid cleaning company", "home maid services", "housekeeping services", "recurring maid service", "maid for hire", "domestic cleaning service"],
    priceFactors: ["Visit frequency", "Home size & task list length", "Laundry and linen add-ons", "One-time vs recurring schedule"],
    faqs: [
      { q: "Will I have the same maid every visit in {city}?", a: "Yes — maid service is built on consistency. {city} clients keep the same dedicated professional, with a trained backup if they're ever away." },
      { q: "Are your maids background-checked?", a: "Every Tbay Cleaning Services maid is background-checked, bonded, insured, and employed by us — never subcontracted." },
      { q: "Can I customize the task list?", a: "Completely. Laundry, linens, dishes, organizing — your standing list is set with your maid and adjusted anytime by calling {phone}." },
    ],
  },
  {
    slug: "pressure-washing",
    name: "Pressure Washing",
    short: "Pressure Washing",
    category: "Exterior",
    icon: "ShowerHead",
    tagline: "High-powered exterior washing for siding, driveways, decks, and storefronts.",
    description: [
      "Canadian seasons are hard on exteriors — salt, algae, grime, and mildew build up fast. Our pressure washing service restores siding, driveways, walkways, decks, fences, and storefronts to like-new condition.",
      "We use surface-appropriate pressure and soft-wash techniques where needed, protecting wood, vinyl, and delicate finishes while stripping away years of buildup.",
    ],
    includes: [
      "House siding soft-washing",
      "Driveway & walkway cleaning",
      "Deck & fence restoration",
      "Patio & interlock washing",
      "Storefront & building exteriors",
      "Parking pads & garage floors",
      "Gutter exteriors & soffits",
      "Algae, mildew & moss treatment",
      "Salt-stain & rust-spot treatment",
      "Pre-paint & pre-sale washes",
    ],
    process: [
      { t: "Surface assessment", d: "We match pressure and method to each surface safely." },
      { t: "Pre-treat", d: "Algae, mildew, and stains treated before washing." },
      { t: "Wash", d: "Soft-wash or pressure wash as appropriate per surface." },
      { t: "Rinse & inspect", d: "Full rinse-down and a final walkthrough with you." },
    ],
    keywords: ["pressure washing services", "power washing", "driveway pressure washing", "deck cleaning", "siding washing", "exterior cleaning services", "pressure washing company", "concrete cleaning", "power washing near me", "house washing service"],
    priceFactors: ["Total surface area", "Surface type & condition", "Stain & treatment requirements", "Water access & height"],
    faqs: [
      { q: "When is pressure washing season in {city}?", a: "Typically spring through fall in {city}. Book early — May and June slots go fastest after the {province} winter." },
      { q: "Will pressure washing damage my siding or deck?", a: "Not with us. We soft-wash delicate surfaces like vinyl and wood, reserving high pressure for concrete and stone." },
      { q: "Do you wash commercial storefronts?", a: "Yes — storefronts, walkways, and building exteriors are a core service for our {city} commercial clients." },
    ],
  },
];
